export default __webpack_public_path__ + "static/media/img6.3c9d9f36.jpg";